import { useCallback } from 'react'

import { type OfferV11, type PimProductV11 } from '@redteclab/api/clients/bully'

import { RECOMMENDATION_WIDGET_BUY_TOGETHER } from '../../recommendation/config/RecommendationAreaType'
import { RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE } from '../../recommendation/config/RecommendationServiceType'
import { useGetRecommendationWidgetId } from '../../recommendation/hooks'
import { recommendationExperimentsTrackRecommendationEvent } from '../../recommendation/recommendation-experiments'
import { experimentsTrackEvent } from '../eventTracking'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION } from '../model/EXPERIMENT_NAME'

type PdpBuyTogetherRecommendationTrackingParams = {
  currentOffer?: OfferV11
  product?: Pick<PimProductV11, 'brand'>
}

export const usePdpBuyTogetherRecommendationTracking = (
  trackEvent: string,
  { currentOffer, product }: PdpBuyTogetherRecommendationTrackingParams = {},
): (() => void) => {
  const pdpBuyTogetherRecommendationExperiment = useGetExperiment(
    EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION,
  )
  const serviceId = RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE
  const widgetId = useGetRecommendationWidgetId(
    serviceId,
    RECOMMENDATION_WIDGET_BUY_TOGETHER,
  )

  return useCallback((): void => {
    if (!pdpBuyTogetherRecommendationExperiment.isEnabled) {
      return
    }

    if (!currentOffer) {
      experimentsTrackEvent(trackEvent)

      return
    }

    recommendationExperimentsTrackRecommendationEvent({
      eventKey: trackEvent,
      productTypeContext: {
        brandName: product?.brand?.name,
        sellerId: currentOffer.seller?.sellerId,
      },
      serviceId,
      widgetId,
    })
  }, [
    currentOffer,
    pdpBuyTogetherRecommendationExperiment.isEnabled,
    product,
    serviceId,
    trackEvent,
    widgetId,
  ])
}
